import "./page-transition.scss";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

const PageTransition = () => {
  /*
  useGSAP(() => {
    let tl = gsap.timeline({ ease: "linear" });
    tl.to(".page-transition", {
      duration: 0.3,
      backgroundColor: "black",
      opacity: 1,
      rotationX: 90,
    }).to(".page-transition", {
      duration: 0.25,
    });
  });

  return <div className="page-transition"></div>;
  */
};

export default PageTransition;
